module.exports = __webpack_public_path__ + "media/images/footer_logo-d2f60cc6edf6767d5bfa0b05432c35b6.png";